import { InternalApiClient } from '@fourthwall/services/dist/InternalApiClient'
import { createMutationHook } from '@fourthwall/utils'

export const useEnrollCampaignMutation = createMutationHook(InternalApiClient.enrollCampaign, {
  mutationKey: ['enrollCampaign'],
})
